import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('dashboard-hris/index', {params});
    },
    showEhp(params) {
        return Service().get('dashboard-hris/show-ehp', {params});
    },
}